module.exports = __webpack_public_path__ + "fonts/junction-light.e96d9283.woff";